<template>
  <div class="hello">
     <div class="ps-page--my-account">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">

                </ul>
            </div>
        </div>
        <div class="ps-my-account">
            <div class="container">
                <form class="ps-form--account ps-tab-root" @submit.prevent="createAnAccount">
                    <ul class="ps-tab-list">

                    </ul>
                    <div class="ps-tabs">
                      <div v-if="registed" class="alert alert-success" role="alert">
                        Your account has successfully been created. A mail has been sent to you for activation.Thanks
                      </div>
                      <div  v-if="failed" class="alert alert-danger" role="alert">
                        {{ errorm }}
                      </div>
                           <div class="ps-tab active">
                              <div v-if="sent" class="spinner-border" role="status">
                                <span class="visually-hidden">...</span>
                              </div>
                            <div class="ps-form__content">
                                <h5>Register An Account</h5>
                                 <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Full name"
                                    required
                                    v-model="user.name">
                                </div>
                                <div class="form-group">
                                    <input class="form-control"
                                    type="text"
                                    placeholder="Email"
                                    required
                                    v-model="user.email" readonly>
                                </div>
                                <div class="form-group">
                                    <input class="form-control"
                                    type="password"
                                    placeholder="Password"
                                    required
                                    v-model="user.password">
                                </div>
                                 <div class="form-group">
                                    <input class="form-control"
                                    type="password"
                                    placeholder="Password confirmation"
                                    required
                                    v-model="user.confirmation">
                                </div>
                                <div class="form-group submtit">
                                    <button @click="createAnAccount" :disabled="clicked" class="ps-btn ps-btn--fullwidth">Register</button>
                                </div>
                            </div>
                            <div class="ps-form__footer">

                                <ul class="ps-list--social">

                                </ul>
                            </div>
                        </div>

                    </div>
                </form>
                <div class="logo-visitor"><a href="https://entreproamd.com/" target="_blank"><img src="../assets/img/logo-entreproamd.png" alt="Entreproamd Logo"></a></div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import DataService from "@/services/DataService";
export default {
  name: 'Register',
  data() {
    this.getInvitation();
    return {
      clicked: false,
      registed: false,
      failed : false,
      invite_token: this.$route.params.invite_token,
      sent : false,      
      errorm: "",
      user: {
        name : "",
        password: "",
        confirmation: "",
        email: this.email,
      }
    };
  },
    methods: {

    getInvitation(){

      var data = {
        invite_token : this.$route.params.invite_token,
      };

      this.sent = true;   
      DataService.get_invite(data)
        .then(response => {
          this.user.email = response.data.email;
          this.sent = false;   
        })
        .catch(e => {
          console.log(e.response.data);
          this.sent = false;
          if(e.response.status == 404){
            this.errorm = "Route nod found";
          }else if(e.response.status == 500){
             this.errorm = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
              this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
              this.errorm = "Please check your internet.";
          }
          this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          this.failed = true;

        });
    },

    createAnAccount() {
      this.failed = false;
      this.registed = false;
      this.sent = false;

      const lang = navigator.language.substring(0, 2);
      console.log("printing browser language :"+lang);

      var data = {
        name: this.user.name,
        password: this.user.password,
        password_confirmation:this.user.confirmation,
        invite_token : this.invite_token,
        lang:lang
      };

      console.log(data);
      this.clicked = true;
      this.sent = true;
      DataService.registration_post(data)
        .then(response => {

          console.log(response);
          this.sent = false;
          this.registed = true;
          this.user= {name : "", password: "",confirmation: "" };

        })
        .catch(e => {
          console.log(e.response.data);
          this.sent = false;
            if(e.response.status == 404){

            this.errorm = "Route nod found";
          }else if(e.response.status == 500){
             this.errorm = "Sorry , service unavailable at the moment , try again later.";
          }else if(e.response.status == 422){
              this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          }else {
              this.errorm = "Please check your internet.";
          }
          this.errorm = this.$parent.translate_error_message(e.response.data.errors,"errors");
          this.failed = true;
          this.user= {name : "", password: "",confirmation: "" };

        });

         setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);
    },


},
  created(){
         this.$emit("giveway",false);
         this.$parent.token = "";
         console.log("we are in the register created function");
         this.$emit("headerAndFooter",false);
     },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Register.vue